/* eslint-disable no-undef */
import { dbridge } from '@didi/driver-bridge'
import url from './url'
import browser from './browser'
import { resolveQuery, stringifyQuery, concatLocalQuery } from './query'
import { setTitle } from './setTitle'
import JSEncrypt from 'jsencrypt'
import { rsaPublicKey, rsaPrivatekey } from './const'

const baseFontSize = 20
function formatDate(str, lang) {
  let res = ''
  const langQuery = url.parse().lang || 'zh-CN'
  // const sevenDays = 604800000
  if (str) {
    const arr = str.split(/[- :]/)
    const date = new Date(arr[0], arr[1] - 1, arr[2], arr[3], arr[4], arr[5])
    const now = new Date()
    const times = date.getTime()
    const diff = times - now.getTime()
    const expired = lang.expired
    const until = lang.until
    // const expiredAfter = lang.expiredAfter
    const enMonthMap = {
      '01': 'January',
      '02': 'February',
      '03': 'March',
      '04': 'April',
      '05': 'May',
      '06': 'June',
      '07': 'July',
      '08': 'August',
      '09': 'September',
      10: 'October',
      11: 'November',
      12: 'December'
    }

    // if (diff > 0 && diff <= sevenDays) {
    //   const days = Math.ceil(diff / (60 * 60 * 24 * 1000))
    //   res = `${days}${expiredAfter}`
    //   switch (langQuery) {
    //     case 'en-US':
    //       res = res.replace('{{num}}', days)
    //       break
    //     default:
    //       break
    //   }
    // } else
    if (diff < 0) {
      res = expired
    } else {
      res = `${until} ${arr[0]}-${arr[1]}-${arr[2]}`
      if (arr[1].length === 1) {
        arr[1] = `0${arr[1]}`
      }
      switch (langQuery) {
        case 'en-US':
          res = `${until} ${arr[2]} ${enMonthMap[arr[1]]},${arr[0]}`
          break
        default:
          break
      }
    }
  }
  return res
}

function templ(str = '', map = {}) {
  return str.replace(
    /#\{(.+?)\}/g,
    (_, key) => {
      return map[key] || ''
    }
  )
}

function px2rem(size) {
  const intSize = Number(size) || 0
  const remSize = intSize / baseFontSize
  return `${remSize}rem`
}

function px2remStr(str) {
  return str.replace(
    /font-size:\s?(\d+)px?/g,
    (_, size) => {
      const remSize = px2rem(size)
      return `font-size:${remSize}`
    }
  )
}

function replaceSpace(str) {
  return str.replace(/\s/g, '')
}

function insertSpace(rawStr, range) {
  const str = replaceSpace(rawStr)
  if (!/[0-9]/.test(str)) {
    return str
  }
  const strArr = str.split('')
  range.forEach((index) => {
    if (strArr.length - 1 >= index) {
      if (strArr[index] !== ' ') {
        strArr.splice(index, 0, ' ')
      }
    }
  })
  return strArr.join('')
}
// 隐藏银行卡中间号码
const hideBankCard = (value) => {
  if (value && value.length > 12) {
    return `${value.substring(0, 6)} ${'*'.repeat(value.length - 10).replace(/(.{4})/g, '$1 ')}${value.length % 4 ? ' ' : ''}${value.slice(-4)}`
  }
  return value
}

function trim(val) {
  const str = `${val}`
  const rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g
  return str.replace(rtrim, '')
}

function limitFloatLen(rawVal, len = 2) {
  let val = rawVal
  val = val.replace(new RegExp(`^(\\-)*(\\d+)\\.(\\d{${len}}).*$`), '$1$2.$3')
  return val
}

function limitNum(rawVal = '') {
  let val = `${rawVal}`

  val = replaceSpace(val)
  val = val.replace(/[^\d]+/g, '')
  return val
}

function isNum(rawVal) {
  const rNum = /^(\d+|\d+\.\d+)$/
  return rNum.test(rawVal)
}

function replaceRange(s = '', start, end, substitute) {
  const range = end - start
  const len = s.length

  if (start < len) {
    return s.substring(0, start) + Array(range + 1).join(substitute || '*') + s.substring(end)
  }

  return s
}

function randomWord(randomFlag, min, max) {
  let str = ''
  let range = min
  const arr = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z']

  if (randomFlag) {
    range = Math.round(Math.random() * (max - min)) + min
  }
  /* eslint-disable no-plusplus */
  for (let i = 0; i < range; i++) {
    const pos = Math.round(Math.random() * (arr.length - 1))
    str += arr[pos]
  }
  return str
}

function dynamicSet () {
  // eslint-disable-next-line one-var
  var width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth || 0,
    fontSize = width * 20 / 375
  fontSize > 25 && (fontSize = 25)
  if (dynamicSet.cacheWidth === undefined || dynamicSet.cacheWidth !== width) {
    dynamicSet.cacheWidth = width
    document.documentElement.style.fontSize = fontSize + 'px'
  }
}

function dynamicSetFontSize () {
  var count = 5
  dynamicSet()
  var timer = setInterval(function () {
    if (!count) clearInterval(timer)
    dynamicSet()
    count--
  }, 200)
  window.removeEventListener('resize', dynamicSet)
  window.addEventListener('resize', dynamicSet)
}

// 多端回退功能
function handleBack (ctr, options = {}) {
  if (ctr.query.from === 'passenger_app' || ctr.query.from === 'driver_app') {
    if (typeof Fusion !== 'undefined' && Fusion.closePage) {
      Fusion.closePage({
        current_page: options.current_page,
      })
    }
    return
  }
  if (browser.isPassenger || ctr.query.appid * 1 === 10000) {
    // 乘客端
    if (window.DDBridge) {
      window.DDBridge.call('page_close')
    } else {
      Fusion.closePage({}, () => {})
    }
  } else if (browser.isDriver || ctr.query.appid * 1 === 20000) {
    if (dbridge) {
      dbridge.pageClose()
    }
  } else if (ctr.query.from === 'xwebapp') {
    if (browser.isWx) {
      window.wx.miniProgram.postMessage({ data: { errno: 0, error: 'success' } })
      ctr.query.successTo ? window.wx.miniProgram.reLaunch({
        url: decodeURIComponent(decodeURIComponent(ctr.query.successTo))
      }) : window.wx.miniProgram.navigateBack({
        delta: ctr.query.delta
      })
    } else if (browser.isAlipay) {
      window.my.postMessage({ data: { errno: 0, error: 'success' } })
      ctr.query.successTo ? window.my.reLaunch({
        url: decodeURIComponent(decodeURIComponent(ctr.query.successTo))
      }) : window.my.navigateBack({
        delta: ctr.query.delta
      })
    }
  } else {
    // webapp&其他端默认逻辑
    window.history.go(-1)
  }
}

function getParams (ctr, obj) {
  ctr.query.lng = parseFloat(obj.lng) || 0
  ctr.query.lat = parseFloat(obj.lat) || 0
  ctr.query.city_id = parseInt(obj.city_id || obj.cityId)
}

function getLogationInfo (ctr, params) {
  if (ctr.query.from === 'passenger_app' || ctr.query.from === 'driver_app') {
    Fusion.getLocationInfo({}, (ret) => {
      getParams(ctr, ret)
    })
    if (!ctr.query.imei || !ctr.query.appid) {
      Fusion.getSystemInfo({}, (ret) => {
        ctr.query.imei = ret.imei
        ctr.query.appid = parseInt(ret.appid)
      })
    }
    return
  }
  if (browser.isPassenger || ctr.query.appid * 1 === 10000) {
    // 乘客端
    Fusion.getLocationInfo({}, (ret) => {
      getParams(ctr, ret)
    })
    if (!ctr.query.imei || !ctr.query.appid) {
      Fusion.getSystemInfo({}, (ret) => {
        ctr.query.imei = ret.imei
        ctr.query.appid = parseInt(ret.appid)
      })
    }
  } else if (browser.isDriver || ctr.query.appid * 1 === 20000) {
    if (!ctr.query.imei || !ctr.query.appid) {
      dbridge.getSystemInfo((ret) => {
        ctr.query.imei = ret.imei
        ctr.query.appid = parseInt(ret.appid)
      })
    }
    dbridge.getLocationInfo((ret) => {
      getParams(ctr, ret)
    })
  } else {
    getParams(ctr, params)
  }
}

export function getLang (obj) {
  const langVal = (obj.lang && obj.lang.toLocaleLowerCase()) || 'zh-cn'
  return new Promise((resolve) => {
    if (obj.lang) {
      window.sessionStorage.setItem('lang', obj.lang.toLocaleLowerCase())
      resolve()
    } else {
      if (obj.from === 'passenger_app' || obj.from === 'driver_app') {
        Fusion.getSystemInfo({}, (ret) => {
          window.sessionStorage.setItem('lang', (ret && ret.lang && ret.lang.toLocaleLowerCase()) || langVal)
          resolve()
        })
        return
      }
      if (browser.isPassenger || String(obj.appid) === '10000') {
        // 乘客端
        Fusion.getSystemInfo({}, (ret) => {
          window.sessionStorage.setItem('lang', (ret && ret.lang && ret.lang.toLocaleLowerCase()) || langVal)
          resolve()
        })
      } else if (browser.isDriver || String(obj.appid) === '20000') {
        console.log('driver', dbridge)
        dbridge.getSystemInfo((ret) => {
          if (ret && ret.appversion > '6.1.12') {
            window.sessionStorage.setItem('lang', (ret && ret.lang && ret.lang.toLocaleLowerCase()) || langVal)
          } else {
            window.sessionStorage.setItem('lang', langVal)
          }
          resolve()
        })
        resolve()
      } else {
        window.sessionStorage.setItem('lang', langVal)
        resolve()
      }
    }
  })
}

/**
 * 函数柯里化
 * @param {Function} fn 需要柯里化的函数
 * @param {Boolean} delay 是否需要延迟执行
 * @returns {Function}
 */
export function curry(fn, delay) {
  return function curriedFn (...rest) {
      if (fn.length > rest.length) {
          return function (...params) {
              var alParams = rest.concat(params)
              return curriedFn.call(this, ...alParams)
          }
      }
      return delay ? (() => fn(...rest)) : fn.call(this, ...rest)
  }
}

/**
 * 判断类型
 * @param {*} proto
 * @returns {String}
 */
export function getType(proto) {
  const type = Object.prototype.toString.call(proto).toLowerCase()
  return type.slice(8, type.length - 1)
}

/**
 * 对象深合并 _obj 的属性会覆盖 _target 对象
 * @param {object} _target 目标对象
 * @param {object} _obj 需要合入的对象
 * @returns {object}
 */
export function deepAssign(_target, _obj) {
  const dfs = (target, obj) => {
    const keys = Object.keys(obj)
    for (let i = 0, j = keys.length; i < j; i++) {
      const key = keys[i]
      const value = obj[key]
      if (getType(value) === 'object') {
        dfs(target[key], value)
      } else {
        target[key] = value
      }
    }
    return target
  }
  return dfs(_target, _obj)
}

/**
 * 深拷贝
 * @param {*} _obj 需要深拷贝的对象
 * @todo 后续升级可以考虑将 hash 换成 WeakMap
 */
export function deepCopy(_obj) {
  function find (list, f) {
    return list.filter(f)[0]
  }
  const dfs = (obj, hash = []) => {
    if (obj === null) return obj
    if (obj instanceof Date) return new Date(obj)
    if (obj instanceof RegExp) return new RegExp(obj)
    if (typeof obj !== 'object') return obj
    const hit = find(hash, (c) => c.original === obj)
    if (hit) {
      return hit.copy
    }
    let cloneObj = new obj.constructor()
    hash.push({
      original: obj,
      copy: cloneObj,
    })
    for (let key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        cloneObj[key] = dfs(obj[key], hash)
      }
    }
    return cloneObj
  }

  return dfs(_obj)
}

// 加密
export function rsaEncrypt(data) {
  const encryptor = new JSEncrypt()
  encryptor.setPublicKey(rsaPublicKey) // 设置公钥
  return encryptor.encrypt(data)
}

// 解密
export function rsaDecrypt(data) {
  const encryptor = new JSEncrypt()
  encryptor.setPrivateKey(rsaPrivatekey) // 设置私钥
  return encryptor.decrypt(data)
}

export function getIPs(callback) {
  const ip_dups = {}
  const RTCPeerConnection = window.RTCPeerConnection ||
    window.mozRTCPeerConnection ||
    window.webkitRTCPeerConnection
  const mediaConstraints = {
    optional: [{ RtpDataChannels: true }]
  }
  // 这里就是需要的ICEServer了
  const servers = {
    iceServers: [
      { urls: 'stun:stun.services.mozilla.com' },
      { urls: 'stun:stun.l.google.com:19302' },
    ]
  }
  const pc = new RTCPeerConnection(servers, mediaConstraints)
  function handleCandidate(candidate) {
    const ip_regex = /([0-9]{1,3}(\.[0-9]{1,3}){3}|[a-f0-9]{1,4}(:[a-f0-9]{1,4}){7})/
    const hasIp = ip_regex.test(candidate)
    if (hasIp) {
      const ip_addr = candidate.match(ip_regex)[0]
      if (ip_dups[ip_addr] === undefined) {
        callback(ip_addr)
      }
      ip_dups[ip_addr] = true
    }
  }
  // 网络协商的过程
  pc.onicecandidate = function (ice) {
    if (ice.candidate) {
      handleCandidate(ice.candidate.candidate)
    }
  }
  pc.createDataChannel('')
  // 创建一个SDP(session description protocol)会话描述协议 是一个纯文本信息 包含了媒体和网络协商的信息
  pc.createOffer(function (result) {
    pc.setLocalDescription(result, function () { }, function () { })
  }, function () { })
  setTimeout(function () {
    if (pc.localDescription && pc.localDescription.sdp) { // 添加空值校验
      var lines = pc.localDescription.sdp.split('\n')
      lines.forEach(function (line) {
        if (line.indexOf('a=candidate:') === 0) {
          handleCandidate(line)
        }
      })
    }
  }, 1000)
}

// 标准化语言传参函数
export function langNormalization (_lang = 'zh-cn') {
  const lang = _lang.toLocaleLowerCase()
  if (lang === 'zh' || lang === 'zh-cn') {
    return 'zh-CN'
  } else if (lang === 'en' || lang === 'en-us') {
    console.log(lang)
    return 'en-US'
  } else {
    return lang
  }
}

/**
 * 格式化身份证号，按6位、10位、14位位数的格式添加空格，并处理光标位置
 * @param {string} value - 输入的身份证号值
 * @param {HTMLInputElement} input - 输入框元素
 * @returns {string} 格式化后的身份证号
 */
export function formatIdNumber(value, input) {
  value = value.replace(/\s/g, '')
  const formatValue = (str) => {
    // 格式：140182 1991 0915 4120
    return str.replace(/^(.{6})(.{0,4})?(.{0,4})?(.*)$/, (_, p1, p2, p3, p4) => {
      return [p1, p2, p3, p4].filter(part => part).join(' ')
    })
  }

  const formatted = formatValue(value)

  if (input) {
    const start = input.selectionStart
    // 优化光标位置计算
    const countSpacesBefore = (str, index) => {
      let count = 0
      for (let i = 0; i < index; i++) {
        if (str[i] === ' ') count++
      }
      return count
    }

    const newPos = start + countSpacesBefore(formatted, start)
    input.setSelectionRange(newPos, newPos)
  }

  return formatted
}

// 白屏监控需要再次重新传入全量配置
function whiteScreenMonitorChange () {
  try {
    window.Omega.setConfig({
      // 白屏监控问题，需要重新传入全量配置
      autoWhiteScreenMonitor: {
        container: '#app',
        checkDisplayNone: true,
        childrenDepth: 4,
        durationSeconds: 5000,
        observerRange: 3
      }
    })
    window.$mounted && window.$mounted()
  } catch (err) {
    console.error(err)
  }
}

export default {
  formatDate,
  templ,
  px2rem,
  px2remStr,
  insertSpace,
  replaceSpace,
  trim,
  limitFloatLen,
  isNum,
  replaceRange,
  limitNum,
  randomWord,
  hideBankCard,
  dynamicSetFontSize,
  handleBack,
  getLogationInfo,
  getLang,
  setTitle,
  resolveQuery,
  stringifyQuery,
  concatLocalQuery,
  curry,
  rsaEncrypt,
  rsaDecrypt,
  getIPs,
  langNormalization,
  formatIdNumber,
  whiteScreenMonitorChange,
}
